import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { Address } from "../types/address.types";
import type { Center } from "../types/center.types";
import type { User } from "../types/user.types";

/**
 * NOTE !!! This value should be incremented in case of breaking changes.
 */
const VERSION = 1;

export interface SignupStoreData {
	user?: Partial<User>;
	code?: string;
	center?: Partial<Center>;
	billingAddress?: Partial<Address>;
	shippingAddress?: Partial<Address>;
}
export interface SignupStoreMethods {
	reset: () => void;
	setUser: (user: Partial<User>) => void;
	setCode: (code: string) => void;
	setCenter: (center: Partial<Center>) => void;
	setBillingAddress: (address: Partial<Address>) => void;
	setShippingAddress: (address: Partial<Address>) => void;
}

const getDefaultState = (): SignupStoreData => ({});

export const useSignupStore = create<SignupStoreData & SignupStoreMethods>()(
	devtools(
		persist(
			(set) => ({
				...getDefaultState(),
				reset: () => set(getDefaultState()),
				setUser: (user) => set({ user }),
				setCode: (code) => set({ code }),
				setCenter: (center: Partial<Center>) => set({ center }),
				setBillingAddress: (address: Partial<Address>) =>
					set({ billingAddress: address }),
				setShippingAddress: (address: Partial<Address>) =>
					set({ shippingAddress: address }),
			}),
			{
				name: "signup-store",
				version: VERSION,
				getStorage: () => localStorage,
			},
		),
	),
);
